<template>
    <header id="mainHeader" class="home-header-wrapper">
        <Logo></Logo>
        <Links></Links>
    </header>
</template>

<script>
import Logo from './Logo.vue';
import Links from './Links.vue';
export default {
    name: "home-header",
    mounted() {
        window.onscroll = function () { myFunction(); };
        var header = document.getElementById("mainHeader");
        var router = document.getElementById("router-view");
        var sticky = header.offsetTop;
        function myFunction() {
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
                router.style.minHeight = "calc(100vh - 100px)";
            }
            else {
                header.classList.remove("sticky");
                router.style.minHeight = "calc(100vh - 100px)";
            }
        }
    },
    components: { Logo, Links }
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
#mainHeader {
    @include mobileBig {
        overflow-x: scroll;
        overflow-y: hidden;
    }
}
.home-header-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    padding: 0 100px 0 100px;
    background-color: white;
    z-index: 12;
    @include mobile {
        padding: 0 30px 0 30px;
    }
    img {
        max-height: 80px;
    }
    .links-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        .router-wrapper {
            display: flex;
        }
        .router-link {
            margin: 10px;
            text-decoration: none;
            font-size: 24px;
            color: #10424b;
            font-weight: 500;
            display: block;
            position: relative;
            overflow: hidden;
            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 0.1em;
                background-color: #10424b;
                opacity: 0;
                transition: opacity 300ms, transform 300ms;
                opacity: 1;
                transform: translate3d(-100%, 0, 0);
            }
            &:hover::after,
            &:focus::after {
                opacity: 1;
                transform: translate3d(0, 0.2em, 0);
                transform: translate3d(0, 0, 0);
            }
            &:nth-child(6) {
                margin-right: 50px;
            }
        }
    }
}
.sticky {
    position: fixed;
    top: 0;
    width: 100%;
    border-bottom: 0.1px solid black;
}

.sticky+#router-view {
    margin-top: 100px;
}
</style>